<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="65rem" @open="open" :title="'禁忌编辑'" @close="cancel">
    <el-form :model="value" :rules="comRules" ref="editor" :label-width="formLabelWidth" style="padding-right:5rem;">
      <el-row>
        <el-col :span="24">
          <el-form-item label="药品名称" prop="name">
            <el-input class="default-input" size="small" type="text" placeholder="请输入药品名称" v-model="value.name">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="类型" prop="type">
            <el-input class="default-input" size="small" type="text" placeholder="请输入类型" v-model="value.type">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="禁忌药品名称" prop="otherName">
            <el-input class="default-input" size="small" type="text" placeholder="请输入禁忌药品名称" v-model="value.otherName">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="memo">
            <el-input class="default-input" size="small" type="textarea" placeholder="请输入备注" :row=2 v-model="value.memo" :disabled="value.disabled">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <!-- <el-button v-if="!value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button> -->
      <el-button type="primary" @click="save" :disabled="isSaving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
import api from "./api";
// import store from "@/common/store"
export default {
  props: {
    value: {},
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      formLabelWidth: "120px",
      // disabledSaveAndNext: false,
      isSaving: false,
      options: {},
      firstDisabled: true,
      comRules: {
        name: [
          { required: true, message: "请输入药品名称", trigger: "blur" },
          { max: 128, message: "药品名称长度在 128 个字符以内", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请输入类型", trigger: "blur" },
          { max: 64, message: "类型长度在 64 个字符以内", trigger: "blur" },
        ],
        otherName: [
          { required: true, message: "请输入禁忌药品名称", trigger: "blur" },
          { max: 64, message: "禁忌药品名称长度在 64 个字符以内", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
    openEditor () {
      // this.disabledSaveAndNext = false;
      this.isSaving = false;
      if (this.value.clientId && this.value.firstMenu != true) {
        this.firstDisabled = false
      }
    },
    save () {
      let _this = this;
      this.$refs.editor
        .validate()
        .then(valid => {
          // _this.disabledSaveAndNext = true;
          _this.isSaving = true;
          return api.Tabu.save(_this.value);
        })
        .then(res => {
          // _this.disabledSaveAndNext = false;
          _this.isSaving = false;
          _this.$message.success("保存成功！");
          _this.$emit("ok", _this.value);
          this.$emit("update:visible", false);
        })
        .catch(err => {
          if (err) {
            _this.$message.error(err.message || err);
          }
          // _this.disabledSaveAndNext = false;
          _this.isSaving = false;
        });
    },
    // saveAndNext () {
    //   this.save();
    // },
    cancel () {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
  }
};
</script>
<style scoped>
</style>

